module.exports = __webpack_public_path__ + "fonts/font.0396cd5.woff2";